export default {
  'pages.home.title': 'Welcome to BEUKAY Packaging Material Mall',
  'pages.home.subTitle':
    'BEUKAY Packaging Mall is a world-class leader in the design, development and manufacture of primary packaging containers for the cosmetics, skin care products, perfume and cosmetics industries,Cooperates with many well-known international brands.',
  'pages.home.contact': 'contact us',
  'pages.home.description': 'Description:',
  'pages.home.news': 'Latest news',
  'pages.home': 'Home',
  'pages.home.search': 'Search',
};
